/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentColor } from './AppointmentColor';
import {
    AppointmentColorFromJSON,
    AppointmentColorFromJSONTyped,
    AppointmentColorToJSON,
    AppointmentColorToJSONTyped,
} from './AppointmentColor';

/**
 * Response for an appointmentType
 * @export
 * @interface AppointmentTypeResponse
 */
export interface AppointmentTypeResponse {
    /**
     * Unique identifier of the appointment type
     * @type {string}
     * @memberof AppointmentTypeResponse
     */
    appointmentTypeId?: string;
    /**
     * Name of appointment type
     * @type {string}
     * @memberof AppointmentTypeResponse
     */
    name?: string;
    /**
     * Status offline of appointment type
     * @type {string}
     * @memberof AppointmentTypeResponse
     */
    offline?: string;
    /**
     * Number of duration base
     * @type {number}
     * @memberof AppointmentTypeResponse
     */
    duration?: number;
    /**
     * duration in minutes
     * @type {number}
     * @memberof AppointmentTypeResponse
     */
    durationMin?: number;
    /**
     * Appointment types order
     * @type {number}
     * @memberof AppointmentTypeResponse
     */
    order?: number;
    /**
     * Additional information
     * @type {string}
     * @memberof AppointmentTypeResponse
     */
    note?: string;
    /**
     * 
     * @type {AppointmentColor}
     * @memberof AppointmentTypeResponse
     */
    color?: AppointmentColor;
    /**
     * Indicate if the appointment type is active
     * @type {boolean}
     * @memberof AppointmentTypeResponse
     */
    active?: boolean;
}

/**
 * Check if a given object implements the AppointmentTypeResponse interface.
 */
export function instanceOfAppointmentTypeResponse(value: object): value is AppointmentTypeResponse {
    return true;
}

export function AppointmentTypeResponseFromJSON(json: any): AppointmentTypeResponse {
    return AppointmentTypeResponseFromJSONTyped(json, false);
}

export function AppointmentTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'offline': json['offline'] == null ? undefined : json['offline'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'durationMin': json['durationMin'] == null ? undefined : json['durationMin'],
        'order': json['order'] == null ? undefined : json['order'],
        'note': json['note'] == null ? undefined : json['note'],
        'color': json['color'] == null ? undefined : AppointmentColorFromJSON(json['color']),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function AppointmentTypeResponseToJSON(json: any): AppointmentTypeResponse {
    return AppointmentTypeResponseToJSONTyped(json, false);
}

export function AppointmentTypeResponseToJSONTyped(value?: AppointmentTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentTypeId': value['appointmentTypeId'],
        'name': value['name'],
        'offline': value['offline'],
        'duration': value['duration'],
        'durationMin': value['durationMin'],
        'order': value['order'],
        'note': value['note'],
        'color': AppointmentColorToJSON(value['color']),
        'active': value['active'],
    };
}

